import React, { useState } from "react";
import { useOrganizationAgreement } from "./useOrgAgreement";

interface OrganizationAgreementCheckboxProps {
  organizationId: string;
  initialChecked?: boolean;
  onUpdateSuccess?: () => void;
  onUpdateError?: (error: any) => void;
  className?: string;
}

export const OrganizationAgreementCheckbox: React.FC<
  OrganizationAgreementCheckboxProps
> = ({
  organizationId,
  initialChecked = false,
  onUpdateSuccess,
  onUpdateError,
  className = "",
}) => {
  const [isChecked, setIsChecked] = useState(initialChecked);
  // const [showDetails, setShowDetails] = useState(false);

  const { updateAgreement, isLoading, error } = useOrganizationAgreement({
    organizationId,
    onSuccess: onUpdateSuccess,
    onError: onUpdateError,
  });

  const handleCheckboxChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newValue = event.target.checked;
    setIsChecked(newValue);

    const success = await updateAgreement(newValue);
    if (!success) {
      // Revert the checkbox state if the API call failed
      setIsChecked(!newValue);
    }
  };

  // const toggleDetails = () => {
  //   setShowDetails(!showDetails);
  // };

  return (
    <div className={`bg-white rounded-lg p-3 ${className}`}>
      {/* Checkbox and main text */}
      <div className="flex items-start space-x-3">
        <input
          type="checkbox"
          id="ai-improvement-agreement"
          checked={isChecked}
          onChange={handleCheckboxChange}
          disabled={isLoading}
          className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <label
          htmlFor="ai-improvement-agreement"
          className="text-gray-900 cursor-pointer"
        >
          <p className="">
            <span>
              We constantly improve the AI Recruiter, so it keeps getting
              smarter and more accurate for everyone.
            </span>
          </p>
        </label>
      </div>

      {/* Toggle details link */}
      {/* <button
        type="button"
        onClick={toggleDetails}
        className="text-blue-600 hover:text-blue-800 text-sm font-medium mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
      >
        {showDetails ? "Hide details" : "Show details"}
      </button> */}

      {/* Detailed information */}
      {isChecked && (
        <div className="mt-2 p-4 bg-[gray]/5 rounded-lg border border-[gray]/20">
          <div>
            <p className="mb-2 font-medium">To do this responsibly:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>
                Anonymised interview data (voice clips, transcripts, scores, and
                final hire/no-hire decisions) may be retained indefinitely for
                the sole purpose of training and improving the AI Recruiter.
              </li>
              <li>
                All personally identifiable information is removed before any
                training use.
              </li>
              <li>
                Candidates explicitly consent to this usage via the on-screen
                consent checkbox before every interview starts.
              </li>
              <li>
                Clients may opt out of contributing their data to model training
                by written notice, in which case their interviews will not be
                used for training purposes.
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* Loading state */}
      {isLoading && (
        <div className="mt-2 text-sm text-gray-500">Accepting...</div>
      )}

      {/* Error state */}
      {error && <div className="mt-2 text-sm text-red-600">Error: {error}</div>}
    </div>
  );
};
